import { Icon } from "@iconify/react";
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import peopleFill from "@iconify/icons-eva/person-fill";
import shoppingBagFill from "@iconify/icons-eva/shopping-bag-fill";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import lockFill from "@iconify/icons-eva/lock-fill";
import personAddFill from "@iconify/icons-eva/person-add-fill";
import refrence from "@iconify/icons-eva/bulb-fill";
import v2v from "@iconify/icons-eva/message-circle-fill";
import camera from "@iconify/icons-eva/image-2-fill";
import setting from "@iconify/icons-eva/settings-2-fill";
import member from "@iconify/icons-eva/person-add-fill";
import login from "@iconify/icons-eva/log-in-fill";
import poll from "@iconify/icons-eva/bar-chart-fill";
import meeting from "@iconify/icons-eva/people-fill";
import event from "@iconify/icons-eva/bookmark-fill";
import country from "@iconify/icons-eva/flag-fill";
import state from "@iconify/icons-eva/funnel-fill";
import city from "@iconify/icons-eva/grid-fill";
import landmark from "@iconify/icons-eva/pin-fill";
import report from "@iconify/icons-eva/file-text-outline";
import chp from "@iconify/icons-eva/file-add-fill";
import mic from "@iconify/icons-eva/volume-up-fill";
import staff from "@iconify/icons-eva/people-outline";
import task from "@iconify/icons-eva/briefcase-fill";
import lead from "@iconify/icons-eva/trending-up-fill";
import bell from "@iconify/icons-eva/bell-fill";
import dashboard from "@iconify/icons-eva/globe-fill";
import cityambassador from "@iconify/icons-eva/shield-fill";
import documents from "@iconify/icons-eva/folder-fill";
import npmFill from "@iconify/icons-eva/npm-fill";
import personDeleteFill from "@iconify/icons-eva/person-delete-fill";
import pricetagsFill from "@iconify/icons-eva/pricetags-fill";
import TourIcon from "@mui/icons-material/Tour";
import Present from "@mui/icons-material/Co2Rounded";
import { CoPresentRounded, FolderShared } from "@mui/icons-material";

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;
let loginUser = JSON.parse(localStorage.getItem("userData"));

// eslint-disable-next-line no-sparse-arrays
const adminconfigData = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard)
  },
  {
    title: "Lead",
    path: "/lead",
    icon: getIcon(lead)
  },
  {
    title: "Lead Reject Reason",
    path: "/lead-reject-reason",
    icon: getIcon("material-symbols:cancel-outline-rounded")
  },
  {
    title: "Downloaded Invoice",
    path: "/download-invoice",
    icon: getIcon("material-symbols:card-membership")
  },
  {
    title: "Welcome Kit",
    path: "/welcome-kit",
    icon: getIcon("material-symbols:card-membership")
  },
  loginUser?.is_subadmin == 0 && {
    title: "Subadmin",
    path: "/subadmin",
    icon: getIcon(staff)
  },
  {
    title: "Training & Webinar",
    path: "/training-webinar",
    icon: getIcon("material-symbols:videocam-outline-rounded")
  },
  {
    title: "Notifications",
    path: "/lvb-notification",
    icon: getIcon(bell)
  },
  {
    title: "Invoice Setting",
    path: "/invoice-setting",
    icon: getIcon(setting)
  },
  {
    title: "Description Edit",
    path: "/description-edit",
    icon: getIcon("material-symbols:description")
  },
  {
    title: "Poll Notification",
    path: "/poll",
    icon: getIcon(poll)
  },
  {
    title: "Member",
    path: "/member",
    icon: getIcon(member)
  },
  {
    title: "Cancel Member Subject",
    path: "/cancel-membership-subject",
    icon: getIcon("material-symbols:cancel")
  },
  {
    title: "Cancel Member Request",
    path: "/cancel-membership-request",
    icon: getIcon("material-symbols:send")
  },
  {
    title: "Membership Flow",
    path: "/membership-flow",
    icon: getIcon("material-symbols:image-outline")
  },
  {
    title: "Magazine",
    path: "/magazine",
    icon: getIcon("material-symbols:menu-book-outline")
  },
  {
    title: "Member Deactivate Reason",
    path: "/member-deactivate-reason",
    icon: getIcon("material-symbols:restart-alt")
  },
  {
    title: "Suggestion",
    path: "/lvb-suggestion",
    icon: getIcon(lead)
  },
  {
    title: "LVB Session & Podcast",
    path: "/lvb-session-podcast",
    icon: getIcon("material-symbols:play-circle-outline")
  },
  {
    title: "Greeting",
    path: "/greeting",
    icon: getIcon(mic)
  },
  {
    title: "Referral Report",
    path: "/referral-report",
    icon: getIcon("material-symbols:group-add-outline")
  },
  // {
  //   title: "Referral Withdrawal",
  //   path: "/referral-withdrawal-requests",
  //   icon: getIcon("material-symbols:payments-outline")
  // },
  {
    title: "Location",
    path: "/location",
    icon: getIcon(landmark),
    children: [
      { title: "Country", path: "/country" },
      { title: "State", path: "/state" },
      { title: "City", path: "/city" }
    ]
  },
  {
    title: "Promotion",
    path: "#",
    icon: getIcon("material-symbols:shield-question-outline"),
    children: [
      { title: "Promotion Reasons", path: "/promotion-reasons" },
      { title: "Promotion", path: "/promotion" }
    ]
  },
  {
    title: "How To Use Application",
    path: "/how-to-use-application",
    icon: getIcon(personDeleteFill)
  },
  {
    title: "Promo Code",
    path: "/lvb-promocode",
    icon: getIcon(lead)
  }
  //   {
  //   title: "Promocode",
  //   path: "/lvb-promocode",
  //   icon: getIcon(lead)
  // },
].filter(Boolean);

// Separate first three (fixed)
const fixedItems = adminconfigData.filter((item) =>
  [
    "Dashboard",
    "Lead",
    "Lead Reject Reason",
    "Downloaded Invoice",
    "Welcome Kit",
    "Member",
    "Member Deactivate Reason",
    "Cancel Member Subject",
    "Cancel Member Request"
  ].includes(item.title)
);

// Get the rest (excluding fixed)
const restItems = adminconfigData.filter(
  (item) =>
    ![
      "Dashboard",
      "Lead",
      "Lead Reject Reason",
      "Downloaded Invoice",
      "Welcome Kit",
      "Member",
      "Member Deactivate Reason",
      "Cancel Member Subject",
      "Cancel Member Request"
    ].includes(item.title)
);

// Sort rest alphabetically by title
const sortedRest = restItems.sort((a, b) => a.title.localeCompare(b.title));

// Final merged list
const settingItem = adminconfigData.find((item) => item.title === "Invoice Setting");
const otherItems = [...fixedItems, ...sortedRest].filter(
  (item) => item.title !== "Invoice Setting"
);
const adminconfig = [...otherItems, settingItem];

const staffconfig = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: getIcon(dashboard)
  },
  {
    title: "Lead",
    path: "/lead",
    icon: getIcon(lead)
  }
];

const sidebarConfig = loginUser?.u_type == 3 ? adminconfig : staffconfig;

export default sidebarConfig;
